// const baseurl = "/api";
const baseurl = process.env.VUE_APP_API_URL;
//打包线上配置
export default baseurl;
